export default {
    intro: 'ฟังเสียงแล้วเขียนให้ถูกต้องกันเลย!',
    introHandwriting: 'ฟังเสียงแล้วเขียนตัวอักษรด้วยมือให้ถูกต้องกันเลย!',
    wordIndex: 'คำที่ {index}',
    common: {
        handwritingView: 'ดูลายมือ',
    },
    student: {
        myAnswer: 'คำตอบที่ฉันส่ง',
        noAnswer: 'ไม่มีคำตอบที่ส่ง',
        answer: 'คำตอบที่ถูก',
        attemptNumber: 'ครั้งที่ {number}',
        listen: 'ตั้งใจฟังกันนะ!<br />ฟังอย่างมีสมาธินะ!',
        teacherReading: 'คุณครูกำลังอ่านให้ฟังด้วยตนเอง',
        listenDirect: 'ตั้งใจฟังประโยคที่คุณครูอ่านให้ฟังนะ!',
        placeholder: 'กรอกคำตอบ',
        wrongToast: 'อุ๊ย ผิดแล้ว ลองกรอกอีกครั้งนะ',
        writeEnd: 'สิ้นสุดการเขียน',
        submitAnswer: 'ส่งคำตอบ',
        replay: 'ฟังอีกครั้ง',
        handwritingPad: {
            progressPrev: 'เลื่อนแถบความคืบหน้าไปทางซ้าย',
            progressNext: 'เลื่อนแถบความคืบหน้าไปทางขวา',
            cellNav: 'ไปที่ช่องที่ {index}',
            bigWriting: 'เขียนตัวใหญ่',
            eraseCell: 'ล้างช่อง',
            scrollLeft: 'เลื่อนไปทางซ้าย',
            scrollRight: 'เลื่อนไปทางขวา',
            submit: 'ส่งคำตอบ',
            tools: {
                pen: 'ปากกา',
                eraser: 'ยางลบ',
                clear: 'ล้างทั้งหมด',
            },
        },
        waitingStart: 'รอสัญญาณเริ่มเขียนจากคุณครูนะ!',
        threeWrong: 'ใช้โอกาสตอบครบ 3 ครั้งแล้ว... รอจนกว่าคุณครูจะเฉลยคำตอบนะ!',
    },
    teacher: {
        setting: {
            activity: 'เนื้อหากิจกรรม',
            number: 'ลำดับ',
            title: 'การเขียนตามคำบอก 📝',
            message: 'หากเล่นประโยคตอนนี้ นักเรียนอาจได้ยินด้วย!',
            subMessage: 'จะเล่นเลยไหม?',
            optionSubMessage: 'หลังจากเล่นครั้งหนึ่งแล้ว หน้าต่างยืนยันจะไม่แสดงอีก',
            confirmText: 'เล่น',
            addQuestion: {
                button: 'เพิ่มโจทย์',
                title: 'เพิ่มโจทย์การเขียนตามคำบอก',
                guide: 'สามารถวางข้อความที่คัดลอกจากภายนอกได้ กรุณากรอกหนึ่งโจทย์ต่อหนึ่งบรรทัด',
                notice: '※ การขึ้นบรรทัดใหม่จะถือเป็นโจทย์ถัดไป และการเว้นวรรค 2 ช่องขึ้นไปจะถูกจัดการเป็นช่องว่างเดียว',
                columnQuestion: 'โจทย์ที่จะเพิ่ม',
                cancelConfirm: {
                    title: 'จะลบโจทย์ที่กรอกไว้ไหม?',
                    body: 'หากยกเลิก โจทย์ที่กรอกมาทั้งหมดจะไม่ถูกเพิ่มและจะถูกลบทั้งหมด\nต้องการดำเนินการต่อหรือไม่?',
                },
                deleteConfirm: {
                    title: 'จะลบโจทย์นี้ไหม?',
                    body: 'หากลบ โจทย์ที่เพิ่มจะถูกนำออกจากรายการ\nต้องการดำเนินการต่อหรือไม่?',
                },
                registering: 'กำลังเพิ่มโจทย์...',
                noticeTitle: 'แจ้งเตือน',
                emptyData: 'กรุณากรอกโจทย์',
                partialFail: 'โจทย์ {count} ข้อไม่ถูกเพิ่มเนื่องจากสร้าง TTS ไม่สำเร็จ',
                duplicateSkip: 'โจทย์ {count} ข้อไม่ถูกเพิ่มเพราะซ้ำกับโจทย์ที่มีอยู่แล้ว',
                addFail: 'เพิ่มโจทย์ไม่สำเร็จ',
                deleteFail: 'ลบโจทย์ไม่สำเร็จ',
                ttsSuccess: 'สร้าง TTS แล้ว',
                ttsFail: 'สร้าง TTS ไม่สำเร็จ',
            },
            inputMode: 'วิธีกรอกคำตอบ',
            inputModeKeyboard: 'แป้นพิมพ์',
            inputModeHandwriting: 'ลายมือ',
            tracing: 'เขียนตาม',
            allowReplay: 'นักเรียนฟังซ้ำได้',
            allowReplayDesc: '*แนะนำให้ใช้ตัวเลือกนี้เมื่อชั้นเรียนมีหูฟังหรือเฮดเซตให้',
            previewGuide: ' เมื่อกดจะสามารถฟังตัวอย่างก่อนได้!',
            generateTts: 'สร้าง TTS',
        },
        handwritingModal: {
            title: 'ลายมือคำตอบของนักเรียนแต่ละคน',
            answer: 'คำตอบที่ถูก',
            notAttempted: 'ยังไม่ได้ลอง',
        },
        question: 'ข้อ',
        intro: 'กรุณาเลือกคำจากโจทย์ทางซ้าย',
        ttsStart: 'เล่นแล้วเริ่มเขียน',
        directReading: 'อ่านให้ฟังด้วยตนเอง',
        startWriting: 'เริ่มเขียน',
        completeWriting: 'เขียนเสร็จและเฉลยคำตอบ',
        viewStudentResult: 'ดูผลของนักเรียนทั้งหมด',
        toast: {
            alreadyDone: 'เป็นคำที่ทำไปแล้ว',
            fiveSeconds: 'สามารถกดเขียนเสร็จได้หลังจากเริ่มเขียนไปแล้ว 5 วินาที',
        },

        // 결과 페이지
        result: {
            title: 'อัตราการตอบถูกแยกตามข้อ',
            order: 'ลำดับ',
            question: 'ข้อ',
            answerRate: 'อัตราการตอบถูก',
        },
    },
    table: {
        question: 'โจทย์',
        answerRate: 'อัตราการตอบถูก',
        emptyMessage: 'ไม่มีเนื้อหา',
    },
};
